'use strict';

import ThemeManager from 'material-ui/lib/styles/theme-manager';

import Colors from 'material-ui/lib/styles/colors';
import ColorManipulator from 'material-ui/lib/utils/color-manipulator';

import Spacing from 'material-ui/lib/styles/spacing';

import colors from 'colors.json';

const theme = ThemeManager.getMuiTheme({
    spacing: Spacing,
    fontFamily: 'Roboto, sans-serif',
    palette: {
        primary1Color: "#EF6569",
        primary2Color: "#6F2F31",
        primary3Color: Colors.lightBlack,
        accent1Color: "#74D9E1",
        accent2Color: Colors.grey100,
        accent3Color: Colors.grey500,
        textColor: Colors.darkBlack,
        alternateTextColor: Colors.white,
        borderColor: Colors.grey300,
        canvasColor: Colors.white,
        disabledColor: ColorManipulator.fade(Colors.darkBlack, 0.3)
    }
});

export { colors };
export default theme;



// WEBPACK FOOTER //
// ./ui/mui.js